import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ordersUrl } from "../../api";
import ModelViewer from "../ModelViewer";
import moment from "moment";

const OrderDetails = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(ordersUrl + id)
      .then((res) => res.json())
      .then((data) => {
        setOrder(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid p-4">Loading order details...</div>
        </section>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid p-4">Order not found.</div>
        </section>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Order Details: {order._id}</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><Link to="/orders">Orders</Link></li>
                <li className="breadcrumb-item active">Details</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* Customer & Order Info Card */}
            <div className="col-md-12">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-user mr-1"></i>
                    Customer Information
                  </h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <strong>Name:</strong> {order.address.name}
                    </div>
                    <div className="col-md-3">
                      <strong>Email:</strong> {order.address.email}
                    </div>
                    <div className="col-md-3">
                      <strong>Phone:</strong> {order.address.phone}
                    </div>
                    <div className="col-md-3">
                      <strong>Status:</strong> <span className={`status badge bg-${getStatusColor(order.status)} ps-2 pe-2`}>{order.status}</span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <strong>Address:</strong> {order.address.address}, {order.address.pin}
                    </div>
                    <div className="col-md-3">
                      <strong>Date:</strong> {moment(order.createdAt).format("DD/MM/YYYY HH:mm")}
                    </div>
                     <div className="col-md-3">
                      <strong>Total:</strong> {order.total}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Order Items */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Order Items</h3>
                </div>
                <div className="card-body p-0">
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{width: '40%'}}>Product/Model</th>
                        <th>Details</th>
                        <th>Preview</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.cartItems.map((item, index) => {
                         if (item.isCustom || item.modelFileUrl) {
                           return (
                             <tr key={index}>
                               <td>
                                 <strong>{item.title}</strong>
                                 <br/>
                                 <small className="text-muted">Custom 3D Print</small>
                               </td>
                               <td>
                                  <ul className="list-unstyled small">
                                    <li>Material: <strong>{item.parameters?.material}</strong></li>
                                    <li>Color: <strong>{item.parameters?.color}</strong></li>
                                    <li>Infill: <strong>{item.parameters?.infill}%</strong></li>
                                    <li>Layer Height: <strong>{item.parameters?.layerHeight}</strong></li>
                                    <li>Quantity: <strong>{item.quantity}</strong></li>
                                  </ul>
                               </td>
                               <td>
                                  <div style={{width: '200px', height: '150px', border: '1px solid #ddd', borderRadius: '4px'}}>
                                    <ModelViewer 
                                     fileUrl={`https://backend.cdp3d.com${item.modelFileUrl}`} 
                                      color={item.parameters?.color}
                                      height="100%"
                                    />
                                  </div>
                               </td>
                               <td>
                                 <a 
                                   href={`https://backend.cdp3d.com${item.modelFileUrl}`} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-primary"
                                >
                                  <i className="fas fa-download mr-1"></i> Download STL
                                </a>
                               </td>
                             </tr>
                           )
                         } else {
                           return (
                             <tr key={index}>
                               <td>{item.title}</td>
                               <td>Standard Product</td>
                               <td>-</td>
                               <td>-</td>
                             </tr>
                           )
                         }
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const getStatusColor = (status) => {
  switch(status) {
    case 'pending': return 'primary';
    case 'shipped': return 'warning';
    case 'delivered': return 'success';
    case 'cancelled': return 'danger';
    default: return 'secondary';
  }
}

export default OrderDetails;
